import { render, staticRenderFns } from "./PageRoot.vue?vue&type=template&id=7ec6b0ce"
import script from "./PageRoot.vue?vue&type=script&lang=js"
export * from "./PageRoot.vue?vue&type=script&lang=js"
import style0 from "./PageRoot.vue?vue&type=style&index=0&id=7ec6b0ce&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports